import "./styles.less";

import React, { useContext, useEffect, useState } from "react";
import { useFavorite } from "./hook";
import { useUser } from "shared-components/Components/User/User.hook";
import { HeartIcon } from "shared-components/Components/CustomIcons/HeartIcon/web";
import { Button } from "shared-components/Components/Buttons/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { trackNpsFavoriteAdded } from "shared-components/Components/NpsSurveyCard/npsSurvey.service";
import "./styles.less"

export function Favorite({
	id,
	type = "default",
	isEspecial,
	isDisabledProperty = false,
}: {
	id: any;
	type?: "default" | "justIcon";
	isEspecial?: Boolean;
	isDisabledProperty?: boolean;
}) {
	const [favoriteState, setFavoriteState] = useState(false);
	const { isFavorite, toggleFavorite, loading } = useFavorite({ id });
	const {
		user: { data }
	} = useUser();

	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}

	const successMessage = async (e) => {
		const added = e.data.toggleFavorite.favorites.find(e => e.property_id == id);
		if (added) {
			trackNpsFavoriteAdded();
			handleClickShowNotification({
				message: "Propiedad agregada a favoritos",
				description: "Te avisaremos automáticamente cuando cambie de precio o se actualice su estado.",
			});
		} else {
			handleClickShowNotification({
				message: "Propiedad eliminada de favoritos",
				description: "No recibirás avisos automáticos de la propiedad.",
			});
		}
	};

	// Valido si muestro el error solo si el usuario esta logeado ya que
	// Solo puede ser favorito cuando hay usuario en sesion.
	const errorMessage = async () => {
		if (data && data.me) {
			handleClickShowNotification({
				message: "Error en favoritos",
				description: "Hubo un error. Vuelva a intentarlo.",
				type: "error",
			});
		}
	};

	useEffect(() => {
		if (isFavorite !== favoriteState) setFavoriteState(isFavorite);
	}, [isFavorite]);
	
	return (
		<div
			style={{display: 'inline-block'}}
			className="favorite-container"
		>
			<Button
				type={type == 'justIcon' ? 'noStyle' : 'secondary'}
				disabled={loading || isDisabledProperty}
				className={`favorite-button button button-secondary secondary ${type} ${favoriteState ? "active" : ""}`}
				onClick={e => {
					e.preventDefault()
					e.stopPropagation()

					if (data?.me) setFavoriteState(!favoriteState)

					toggleFavorite()
						.then(successMessage)
						.catch(errorMessage)
				}}
			>
				<HeartIcon
					className={`heart-icon ${favoriteState ? "active" : ""}`}
					width={type !== "justIcon" ? 20 : 28}
				/>

				{!isEspecial
					? type !== "justIcon"
						? favoriteState
							? "Guardado"
							: "Favorito"
						: null
					: null}
			</Button>
		</div>
	)
}
